export enum PriceType {
  Normal,
  Agreement,
  Campaign,
}
